import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { isDefined } from '@grandvisionhq/utils';
import { UnavailableLineItemsContainer } from '../../LineItems/containers/UnavailableLineItemsContainer.js';
import { LineItemsContainer } from '../../LineItems/containers/LineItemsContainer.js';
import { FooterContainer } from '../../Footer/FooterContainer.js';

const Cart = ({ lineItems , unavailableLineItems , readOnly , labels , deliveryResolver , policyItems  })=>{
    // This will be used when the basic variant of the DeliveryIndicator is enabled
    const availability = lineItems.map((item)=>item.availability
    );
    // This will be used if the full date variant of the DeliveryIndicator is enabled (feature toggle)
    const deliveryItems = lineItems.map((item)=>{
        if ('sku' in item) {
            return {
                sku: item.sku,
                quantity: item.quantity
            };
        }
    }).filter(isDefined);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('cart', {
            'cart--read-only': readOnly
        }),
        "data-t": "cart"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "cart__heading"
    }, labels.cartTitle), /*#__PURE__*/ React__default.createElement("div", {
        className: "cart__content"
    }, !!lineItems.length && /*#__PURE__*/ React__default.createElement(DeliveryIndicator, {
        items: deliveryItems,
        availability: availability,
        deliveryResolver: deliveryResolver
    }), /*#__PURE__*/ React__default.createElement(LineItemsContainer, {
        lineItems: lineItems
    }), /*#__PURE__*/ React__default.createElement(UnavailableLineItemsContainer, {
        unavailableLineItems: unavailableLineItems,
        labels: labels
    })), /*#__PURE__*/ React__default.createElement(FooterContainer, {
        readOnly: readOnly,
        policyItems: policyItems,
        unavailableLineItems: unavailableLineItems
    }));
};

export { Cart };
//# sourceMappingURL=Cart.js.map
